import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Grid,
  InputLabel,
  Checkbox,
  IconButton,
  Collapse,
  FormHelperText,
  Box,
  Tooltip,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";


import "react-datepicker/dist/react-datepicker.css";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { AgGridReact } from "ag-grid-react";
import {
  editReport,
  getExcelReport,
  getPerformanceReports,
  getReports,
} from "../../api/reportApi/reportApi";
import { Col, Form, Row } from "react-bootstrap";
import ScheduleReport from "./ScheduleReport";
import { useLoader } from "../../context/LoaderContext";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
interface PerformanceReportProps {
  businessUnitData: any;
}
const PerformanceReport: React.FC<PerformanceReportProps> = ({
  businessUnitData,
}) => {
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [report, setReport] = useState<any>([]);
  const [editReportData, setEditReportData] = useState([]);
  const [selectedReportId, setSelectedReportId] = useState(1);
  const [formData, setFormData] = useState({
    scheduleReportId: report.length > 0 ? report[0].scheduleReportId : "",
  });
  const [isDownsampleChecked, setIsDownsampleChecked] = useState(false);
  const [isPrintChecked, setIsPrintChecked] = useState(false);
  const [isPreworkChecked, setIsPreworkChecked] = useState(false);
  const [isWebEDeliveryChecked, setIsWebEDeliveryChecked] = useState(false);
  const [isPrintEDeliveryChecked, setIsPrintEDeliveryChecked] = useState(false);
  const [isMisssedSlaChecked, setIsMisssedSlaChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const gridRef = useRef<AgGridReact>(null);
  const { setLoading } = useLoader();
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
  };
  const { showSnackbar } = useSnackbar();
  const columnDefs = useMemo(() => {
    const headersDisplayNames: Record<string, string> = {
      projectDocumentId: "Doc ID",
      createDate: "CreatedDate",
      lessThanTwo: "Less than 2 hours",
      greaterThanTwo: "Greater than 2 hours",
      lessThanFour: "Less than 4 hours",
      withinFourToTwentyFour: "Within 4 to 24 hours",
      greaterThanTwentyFour: "Greater than 24 hours",
      missedSLA: "Missed SLA's",
    };
    let predefinedColumns = [
      {
        width: 50,
        sortable: false,
        filter: false,
        colId: "checkboxSelection",
      },
      {
        headerName: "#",
        width: 90,
        sortable: false,
        filter: false,
        resizable: false,
        colId: "rowIndex",
        valueGetter: (params: any) => {
          return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
        },
      },
    ];

    const generateDynamicColumns = (
      rowData: any,
      selectedHeaders: string[]
    ) => {
      if (!rowData || rowData.length === 0) {
        return [];
      }
      const columnsToExclude = [
        "toDSA",
        "fromDSA",
        "toDAO",
        "fromDAO",
        "deleted",
        "eDelivery",
        "sortColumn",
        "contextName",
        "toDate",
        "eDeliveryPass",
        "toPreflight",
        "fromPreflight",
        "totalRecords",
        "rowCounts",
        "isexporttpExcel",
      ];
      return Object.keys(rowData[0])
        .filter(
          (key) =>
            selectedHeaders.includes(key) &&
            !columnsToExclude.includes(key) &&
            rowData.every((row: any) => row[key] !== 0 && row[key] !== "")
        )
        .map((key) => ({
          headerName: headersDisplayNames[key] || key,
          field: key,
          tooltipField: key,
          width: 530,
          flex: 1,
          colId: key,
          sortable: true,
          filter: true,
        }));
    };
    const generateHeadersMap = (rowData: any) => {
      if (!rowData || rowData.length === 0) {
        return {};
      }
      const availableHeaders = Object.keys(rowData[0]);
      return {
        default: availableHeaders,
        downSample: availableHeaders.filter(
          (key) =>
            key === "projectDocumentId" ||
            key === "lessThanTwo" ||
            key === "greaterThanTwo"
        ),
        prework: availableHeaders.filter(
          (key) =>
            key === "projectDocumentId" ||
            key === "createDate" ||
            key === "lessThanFour" ||
            key === "withinFourToTwentyFour" ||
            key === "greaterThanTwentyFour"
        ),
        missedSla: availableHeaders.filter(
          (key) => key === "projectDocumentId" || key === "missedSLA"
        ),
        preworkAndMissedSla: availableHeaders.filter(
          (key) =>
            key === "projectDocumentId" ||
            key === "createDate" ||
            key === "missedSLA"
        ),
      };
    };
    let headersMap =
      rowData && rowData.length > 0 ? generateHeadersMap(rowData) : {};
    let selectedHeaders = headersMap.default || [];
    if ((isPreworkChecked || !isPreworkChecked) && isMisssedSlaChecked) {
      selectedHeaders = headersMap.preworkAndMissedSla || [];
    } else if (isPreworkChecked) {
      selectedHeaders = headersMap.prework || [];
    } else if (isMisssedSlaChecked) {
      selectedHeaders = headersMap.missedSla || [];
    } else if (isDownsampleChecked) {
      selectedHeaders = headersMap.downSample || [];
    }
    const dynamicColumns = generateDynamicColumns(rowData, selectedHeaders);
    const allColumns = [...predefinedColumns, ...dynamicColumns];
    return allColumns;
  }, [rowData]);

  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    handleEditReport(value);
  };

  const handleEditReport = async (value: any) => {
    setLoading(true);
    const payload = {
      contextName:
        businessUnitData?.contextName || LocalStorageUtil.getItem("contextName"),
      schedulerobj: {
        ScheduleReportId: value,
        Timezone: appSettings.timezone,
      },
    };
    try {
      const response = await editReport(payload);
      setLoading(false);
      setEditReportData(response);
      setIsOpen(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setRowData([]);
    setStartDateError(false);
    setEndDateError(false);
  };

  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: appSettings.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const formatDate = (date: any) => {
    if (!date) return null;
    const parts = formatter.formatToParts(date).reduce((acc: any, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    return `${parts.year}-${parts.month}-${parts.day}`;
  };

  const handleApplyClick = async (checkedValue?: any, reporttype?: any) => {
    let valid = true;
    if (!startDate) {
      setStartDateError(true);
      valid = false;
    } else {
      setStartDateError(false);
    }
    if (!endDate) {
      setEndDateError(true);
      valid = false;
    } else {
      setEndDateError(false);
    }
    if (!valid) {
      return;
    }
    const payload = {
      AccountId:
        businessUnitData?.accountId || LocalStorageUtil.getItem("accountId"),
      Fromdate: formatDate(startDate),
      MissedSlaCheck: checkedValue.button === 0 ? false : checkedValue,
      Timezone: appSettings.timezone,
      Todate: formatDate(endDate),
      contextName:
        businessUnitData?.contextName || LocalStorageUtil.getItem("contextName"),
      currentPage: 1,
      noOfRecords: 25,
      reporttype: reporttype ?? selectedReportId,
    };
    setLoading(true);
    try {
      const response = await getPerformanceReports(payload);
      setLoading(false);
      setRowData(response);
    } catch (error) {
      console.log("failed to load", error);
      setLoading(false);
    }
  };

  const fetchReport = async () => {
    setLoading(true);
    const payload = {
      contextName:
        businessUnitData?.contextName || LocalStorageUtil.getItem("contextName"),
      schedulerobj: {
        AccountId:
          businessUnitData?.accountId || LocalStorageUtil.getItem("accountId"),
      },
    };
    try {
      const response = await getReports(payload);
      setLoading(false);
      setReport(response);
    } catch (error) {
      console.log("fail to load", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchReport();
  }, [businessUnitData]);

  useEffect(() => {
    console.log("Current state of isMisssedSlaChecked:", isMisssedSlaChecked);
  }, [isMisssedSlaChecked]);
  const generatePayload = () => {
    const multiExportToExcel = [];
    if (isDownsampleChecked) {
      multiExportToExcel.push({
        id: 1,
        Report: "Downsample",
        isChecked: true,
        ReportTypeId: "Downsample",
        Queueid: 303,
      });
    }
    if (isPrintChecked) {
      multiExportToExcel.push({
        id: 2,
        Report: "Print",
        isChecked: true,
        ReportTypeId: "Print",
        Queueid: 304,
      });
    }
    if (isPreworkChecked) {
      multiExportToExcel.push({
        id: 4,
        Report: "Prework",
        isChecked: true,
        ReportTypeId: "Prework",
        Queueid: 305,
      });
    }
    if (isWebEDeliveryChecked) {
      multiExportToExcel.push({
        id: 8,
        Report: "WebEdelivery",
        isChecked: true,
        ReportTypeId: "Web eDelivery",
        Queueid: 307,
      });
    }
    if (isPrintEDeliveryChecked) {
      multiExportToExcel.push({
        id: 16,
        Report: "PrintEdelivery",
        isChecked: true,
        ReportTypeId: "Print eDelivery",
        Queueid: 306,
      });
    }
    return {
      accountid: LocalStorageUtil.getItem("accountId"),
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      pagename: "Performance",
      aliasname: "Performance",
      downsamplealiasname: "Downstream Report",
      preworkaliasname: "Prework Report",
      webedeliveryaliasname: "Web eDelivery Report",
      printedeliveryaliasname: "Print eDelivery Report",
      reporttype: 1,
      currentPage: 1,
      noOfRecords: 0,
      multiExportToExcel,
      MissedSlaCheck: false,
      contextName: LocalStorageUtil.getItem("contextName"),
      Timezone: appSettings.timezone,
      offset: appSettings.timezone,
    };
  };
  console.log("Genarate payload:", generatePayload);
  const excelData = async () => {
    let valid = true;
    if (!startDate) {
      setStartDateError(true);
      valid = false;
    } else {
      setStartDateError(false);
    }
    if (!endDate) {
      setEndDateError(true);
      valid = false;
    } else {
      setEndDateError(false);
    }
    if (!valid) {
      return;
    }
    setLoading(true);
    const payload = {
      accountid: LocalStorageUtil.getItem("accountId"),
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      pagename: "Performance",
      aliasname: "Performance",
      downsamplealiasname: "Downstream Report",
      preworkaliasname: "Prework Report",
      webedeliveryaliasname: "Web eDelivery Report",
      printedeliveryaliasname: "Print eDelivery Report",
      reporttype: 1,
      currentPage: 1,
      noOfRecords: 0,
      MissedSlaCheck: false,
      contextName: LocalStorageUtil.getItem("contextName"),
      Timezone: appSettings.timezone,
      offset: appSettings.timezone,
    };
    try {
      const excelDataResponse = await getExcelReport(payload);
      setLoading(false);
      const blob = new Blob([excelDataResponse], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ReportsData.xlsx");
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
      showSnackbar("File downloaded successfully!");
      if (!excelDataResponse) {
        showSnackbar("No records Found!");
      }
    } catch (error) {
      console.error("Error fetching Excel data", error);
      setLoading(false);
    }
  };

  const handleCallback = () => {
    setIsOpen(false);
    setFormData((prev) => ({ ...prev, scheduleReportId: "" }));
    fetchReport();
  };
  return (
    <div>
      <NavigationBar title="Performance Report" text="Performance Report" />
      {!isOpen ? (
        <Row style={{ margin: "1em" }}>
          <Col>
            <Box>
              <div className="rp-main-inner col-sm-12">
                <div className="queue-top row clearfix">
                  <div
                    className="col-sm-8"
                    style={{
                      display: "flex",
                      gap: "0.625em",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                      marginTop: "1.25em",
                      width: "66%",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <InputLabel
                        style={{
                          color: "var(--text-color)",
                          marginBottom: "0.25em",
                          fontWeight: 600,
                          fontSize: "11px",
                        }}
                      >
                        From Date: *
                      </InputLabel>
                      <Form.Control
                        type="date"
                        placeholder="From Date"
                        name="fromdate"
                        max={new Date().toISOString().split("T")[0]}
                        value={
                          startDate ? startDate.toISOString().split("T")[0] : ""
                        }
                        onChange={(e) => setStartDate(new Date(e.target.value))}                       
                        style={{
                          padding: ".3em",
                          width: "150px",
                          fontSize: "11px",
                          borderRadius: "0",
                          border: "1px solid #ccc",
                          borderColor: "black",
                          marginTop: ".1em",
                        }}
                      />
                      <div style={{ height: "1.25em" }}>
                        {startDateError && (
                          <FormHelperText error sx={{ marginTop: "0.25em" }}>
                            Please select date
                          </FormHelperText>
                        )}
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <InputLabel
                        style={{
                          color: "var(--text-color)",
                          marginBottom: "0.25em",
                          fontWeight: 600,
                          fontSize: "11px",
                          marginLeft: ".5em",
                        }}
                      >
                        To Date: *
                      </InputLabel>
                      <Form.Control
                        type="date"
                        placeholder="To Date"
                        name="todate"
                        value={
                          endDate ? endDate.toISOString().split("T")[0] : ""
                        }
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) => setEndDate(new Date(e.target.value))}                       
                        style={{
                          padding: ".3em",
                          width: "150px",
                          fontSize: "11px",
                          borderRadius: "0",
                          border: "1px solid #ccc",
                          borderColor: "black",
                          marginTop: ".1em",
                          marginLeft: ".5em",
                        }}
                      />
                      <div style={{ height: "1.25em" }}>
                        {endDateError && (
                          <FormHelperText error sx={{ marginTop: "0.25em" }}>
                            Please select date
                          </FormHelperText>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "0.5em",
                        alignItems: "center",
                        marginTop: "1.3em",
                        fontSize: "14px",
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleApplyClick}
                        className="button apply-button"
                        style={{
                          marginLeft: ".5em",
                        }}
                      >
                        Apply
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleReset}
                        className="button reset-button"
                      >
                        Reset
                      </Button>
                    </div>
                  </div>
                  <div
                    className="col-sm-4"
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "right",
                      marginTop: "2vh",
                      width: "15%",
                      height: "1.875em",
                      marginLeft: "32vh",
                    }}
                  >
                    <Form.Select
                      name="scheduleReportId"
                      value={formData.scheduleReportId}
                      onChange={handleChange}
                      style={{
                        fontSize: "11px",
                        height: "28px",
                      }}
                    >
                      <option value="">Select Report</option>
                      {report.map((report: any) => (
                        <option
                          key={report.scheduleReportId}
                          value={report.scheduleReportId}
                        >
                          {report.reportName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div
                    className="col-sm-12"
                    style={{
                      display: "flex",
                      gap: "0.5vh",
                      alignItems: "center",
                      marginTop: "2vh",
                    }}
                  >
                    {/* Dates, Apply and Reset buttons */}
                    <div
                      className="col-sm-8"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1vh",
                      }}
                    >
                      {isPagePermission(
                        "Allow Downsample",
                        "PerformanceReport",
                        303
                      ) && (
                        <Button
                          variant="contained"
                          size="small"
                          className="checkbox-button"
                          onClick={() => {
                            setIsDownsampleChecked(!isDownsampleChecked);
                            setSelectedReportId(1);
                            !isMisssedSlaChecked
                              ? handleApplyClick(false, 1)
                              : handleApplyClick(true, 1);
                          }}
                        >
                          <Checkbox
                            className="custom-checkbox-wrapper"
                            checked={isDownsampleChecked}
                            onChange={(e) =>
                              setIsDownsampleChecked(e.target.checked)
                            }
                            sx={{
                              padding: "0",
                              marginRight: "0.8vh",
                              color: "white",
                              minHeight: "5px",
                              minWidth: "5px",
                            }}
                          />
                          DOWNSAMPLE
                        </Button>
                      )}
                      {isPagePermission(
                        "Allow Print",
                        "PerformanceReport",
                        304
                      ) && (
                        <Button
                          variant="contained"
                          size="small"
                          className="checkbox-button"
                          onClick={() => {
                            setIsPrintChecked(!isPrintChecked);
                            setSelectedReportId(2);
                            !isMisssedSlaChecked
                              ? handleApplyClick(false, 2)
                              : handleApplyClick(true, 2);
                          }}
                        >
                          <Checkbox
                            className="custom-checkbox-wrapper"
                            checked={isPrintChecked}
                            onChange={(e) =>
                              setIsPrintChecked(e.target.checked)
                            }
                            sx={{
                              padding: "0",
                              marginRight: "0.8vh",
                              color: "white",
                            }}
                          />
                          PRINT
                        </Button>
                      )}
                      {isPagePermission(
                        "Allow Prework",
                        "PerformanceReport",
                        305
                      ) && (
                        <Button
                          variant="contained"
                          size="small"
                          className="checkbox-button"
                          onClick={() => {
                            setIsPreworkChecked(!isPreworkChecked);
                            setSelectedReportId(4);
                            !isMisssedSlaChecked
                              ? handleApplyClick(false, 4)
                              : handleApplyClick(true, 4);
                          }}
                        >
                          <Checkbox
                            className="custom-checkbox-wrapper"
                            checked={isPreworkChecked}
                            onChange={(e) =>
                              setIsPreworkChecked(e.target.checked)
                            }
                            sx={{
                              padding: "0",
                              marginRight: "0.8vh",
                              color: "white",
                            }}
                          />
                          PREWORK
                        </Button>
                      )}
                      {isPagePermission(
                        "Allow Web Edelivery",
                        "PerformanceReport",
                        307
                      ) && (
                        <Button
                          variant="contained"
                          size="small"
                          className="checkbox-button"
                          onClick={() => {
                            setIsWebEDeliveryChecked(!isWebEDeliveryChecked);
                            setSelectedReportId(8);
                            !isMisssedSlaChecked
                              ? handleApplyClick(false, 8)
                              : handleApplyClick(true, 8);
                          }}
                        >
                          <Checkbox
                            className="custom-checkbox-wrapper"
                            checked={isWebEDeliveryChecked}
                            onChange={(e) =>
                              setIsWebEDeliveryChecked(e.target.checked)
                            }
                            sx={{
                              padding: "0",
                              marginRight: "0.8vh",
                              color: "white",
                            }}
                          />
                          WEB EDELIVERY
                        </Button>
                      )}
                      {isPagePermission(
                        "Allow Print Edelivery",
                        "PerformanceReport",
                        306
                      ) && (
                        <Button
                          variant="contained"
                          size="small"
                          className="checkbox-button"
                          onClick={() => {
                            setIsPrintEDeliveryChecked(
                              !isPrintEDeliveryChecked
                            );
                            setSelectedReportId(16);
                            !isMisssedSlaChecked
                              ? handleApplyClick(false, 16)
                              : handleApplyClick(true, 16);
                          }}
                        >
                          <Checkbox
                            className="custom-checkbox-wrapper"
                            checked={isPrintEDeliveryChecked}
                            onChange={(e) =>
                              setIsPrintEDeliveryChecked(e.target.checked)
                            }
                            sx={{
                              padding: "0",
                              marginRight: "0.8vh",
                              color: "white",
                            }}
                          />
                          PRINT EDELIVERY
                        </Button>
                      )}
                    </div>
                    {/* Grid Preferences and export to excel */}
                    <div
                      className="col-sm-4"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        content: "flex-end",
                        justifyContent: "flex-end",
                        width: "32%",
                      }}
                    >
                      {
                        isPagePermission("Allow Scheduler","PerformanceReport",308)&&(<Button
                          variant="contained"
                          size="small"
                          onClick={handleClick}
                          className="button checkbox-button"
                        >
                          Schedule
                          <IconButton
                            size="small"
                            sx={{
                              padding: 0,
                              marginLeft: "0.8vh",
                              color: "inherit",
                            }}
                          >
                            {isOpen ? (
                              <ArrowDropUpIcon fontSize="small" />
                            ) : (
                              <ArrowDropDownIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Button>)
                      }
                      {rowData.length > 0 && isPagePermission("Allow Export To Excel","PerformanceReport",302)&& (
                        <Tooltip title="Click to export the grid content in excel">
                          <button
                            type="button"
                            onClick={excelData}
                            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                            aria-label="Export to Excel"
                          >
                            <img
                              src={ExcelIcon}
                              className="excel-icon"
                              alt="Excel Icon"
                              style={{ marginTop: ".3em" }}
                            />
                          </button>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <Checkbox
                      checked={isMisssedSlaChecked}
                      onChange={(e) => {
                        const checkedValue = e.target.checked;
                        setIsMisssedSlaChecked(checkedValue);
                        handleApplyClick(checkedValue);
                      }}
                      sx={{
                        padding: "0",
                        marginRight: "0.8vh",
                        color: "var(--text-color)",
                      }}
                    />
                    <span
                      style={{ color: "var(--text-color)", marginTop: "1vh" , fontSize: "11px"}}
                    >
                      Show Missed SLA's
                    </span>
                  </div>
                  {/* AgGrid */}
                  <div className="queue-table-view clearfix">
                    <div
                      className="ag-theme-quartz-dark"
                      style={{
                        height: "60vh",
                        width: "99%",
                        marginTop: "2vh",
                      }}
                    >
                      <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        pagination={true}
                        paginationPageSize={defaulPageSize}
                        paginationPageSizeSelector={pageSizeSelector}
                        rowGroupPanelShow="always"
                        pivotPanelShow="always"
                        gridOptions={{
                          rowSelection: { 
                            mode : "multiRow",
                            checkboxes: true,
                            headerCheckbox: true,
                            enableClickSelection: false,
                           },  
                        }}
                        defaultColDef={defaultColDef}
                        ref={gridRef}
                        loading={!rowData}
                        loadingOverlayComponent={CustomLoadingOverlay}
                        overlayNoRowsTemplate={
                          '<span class="ag-overlay-loading-center">No rows to show</span>'
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Col>
        </Row>
      ) : (
          <Collapse in={isOpen}>
            <div>
              <Grid
                container
                spacing={2}
                sx={{
                  marginTop: "2vh",
                  display: "flex",
                  justifyContent: "end",
                }}
                alignItems="center"
              >
                <Form.Group
                  controlId="formCustomer"
                  style={{ marginRight: "2vh" }}
                >
                  <Form.Select
                    data-testid="scheduleReportId"
                    name="scheduleReportId"
                    value={formData.scheduleReportId}
                    onChange={handleChange}
                    style={{
                      fontSize: "11px",
                      height: "28px",
                      width: "15em",                      
                    }}

                  >
                    <option value="">Select Report</option>
                    {report.map((report: any) => (
                      <option
                        key={report.scheduleReportId}
                        value={report.scheduleReportId}
                      >
                        {report.reportName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleClick}
                  sx={{
                    backgroundColor: "var(--button-background-color)",
                    color: "var(--text-color)",
                    textTransform: "none",
                    fontSize: "11px",
                    padding: "1em .4em",
                    height: "2.5em",
                    borderRadius: 0,
                    marginRight: "1em",
                    width: "8em",
                  }}
                >
                  Schedule
                  <IconButton
                    size="small"
                    sx={{ padding: 0, marginLeft: "0.5em", color: "inherit" }}
                  >
                    {isOpen ? (
                      <ArrowDropUpIcon fontSize="small" />
                    ) : (
                      <ArrowDropDownIcon fontSize="small" />
                    )}
                  </IconButton>
                </Button>
              </Grid>
              {isOpen && (
                <ScheduleReport
                  editReportData={editReportData}
                  performanceReportCallback={handleCallback}
                />
              )}
            </div>
          </Collapse>
      )}
    </div>
  );
};

export default PerformanceReport;
